//import AspectRatio from "@mui/joy/AspectRatio";
import { Box } from '@mui/material'
import { BaseImage } from '../baseImage/baseImage'
import classNames from 'classnames'

export const ResponsiveImage = ({
  ratio,
  src,
  alt = "",
  width = '100%',
  maxWidth = 'unset',
  className,
  sources,
  priority,
  loading,
  sx,
  ...props
}) => {
  return (
    <Box
      className={classNames('responsive-image', className)}
      ratio={ratio}
      sx={{ backgroundColor: 'transparent', width, maxWidth, ...sx }}
      {...props}
    >
      <BaseImage scale={true} src={src} alt={alt} sources={sources} priority={priority} loading={loading} />
    </Box>
  )
}

export default ResponsiveImage
